export default {"src":"/_next/static/media/instagram-green.2ebc4bf2.svg","height":20,"width":20};